import { createContext } from 'react';
import { PersonalMessagesState } from './usePALMessages';

type PALPanelContext = {
  panelAreaExpanded: boolean;
  isActivePanel?: boolean;
  messagesStates: PersonalMessagesState[];
};
export const PALPanelContext = createContext<PALPanelContext>({
  panelAreaExpanded: false,
  isActivePanel: undefined,
  messagesStates: [],
});

PALPanelContext.displayName = 'PALPanelContext';
